import MapEntity from "./MapEntity";
import {useEffect, useState} from "react";
import {useHttp} from "../../../context/HttpProvider";
import { ContinueAction } from "../ReportWizardProvider";
import useValueMapping from "./hooks/useValueMapping";

export default function ManufacturerPracticeMapper() {
    const {mappingApi} = useHttp();
    const [hasLoaded, setHasLoaded] = useState(false);
    const [reportUploadId, mappingData, setMappingData, updateMapping, validate, validationLookup] = useValueMapping(ContinueAction.SaveManufacturerPracticeMappings);

    async function getPracticeMappings() {
        var response = await mappingApi.getManufacturerPracticeMappings(reportUploadId);
        if(response) {
            setMappingData(response);
            setHasLoaded(true);
            validate(response);
        }
    }

    useEffect(() => {
        if(mappingApi != null) {
            getPracticeMappings();
        }
    }, [mappingApi])

    return <>
        {hasLoaded && <MapEntity data={mappingData} type="Practice" updateMapping={updateMapping} validationLookup={validationLookup} />}
    </>
}